import { AsModuleHelper, AsStoreModule } from '@/types/vuex/helpers';
import { createNamespacedHelpers, ActionContext, MutationTree, Dictionary } from 'vuex';
import { IRootState } from '@/store/rootstate';
import { ISignupPage } from '@/api/signup/interface';
import { RouteConfig } from 'vue-router';

interface IState {
  pages: string[];
  page: {
    current: string;
    index: number;
    history: Array<{ page: string; index: number; date: number }>;
  };
  components: Dictionary<() => Promise<any>>;
  collectionsPage: number
  collectionsEmploymentPage: number
  collectionsBauPriorityPage: number
  collectionsBusPage: number
  collectionsBusEmploymentPage: number
}

interface IGetters {
  page: string;
  // pageDirection: 1 | 0 | -1;
  // pageInitial: SignupPagesEnum;
}

/* Actions */
interface IActions {
  init(): Promise<any>;

  initMastercardFlow(): Promise<boolean>;
  retryMastercardFlow(): Promise<void>;
  addNewBankMastercard(): Promise<void>;

  pushNewPage(page: RouteConfig): Promise<any>;

  // preloadNext(): Promise<any>;
  firstPage(): Promise<any>;
  navigateTo(page: string, params?: any): Promise<any> | void;

  processPages(signupPages: ISignupPage[]): Promise<string>;

  goToError(error: { title?: string; message?: string }): void;

  next(): Promise<string>;
  previous(): Promise<string>;

  /**
   * Syncs the current router with internal navigation, this allows the navigation to override the route if necessary
   * @param to Next page
   * @param query router query params
   */
  sync(payload: { to?: string; query?: any }): Promise<any>;
  /**
   * Skip the page, if the user is going back it will go back, if is the same or going forward
   * it will go to next page
   */
  skip(): Promise<string>;

  // TODO jump should be only for system_pages
  jump(e: number, params?: any): number;
}
interface IStoreActions<S, R> {
  init(injectee: ActionContext<S, R>): Promise<any> | void;

  initMastercardFlow(injectee: ActionContext<S, R>): Promise<boolean>;
  retryMastercardFlow(injectee: ActionContext<S, R>): Promise<void>;
  addNewBankMastercard(injectee: ActionContext<S, R>): Promise<void>;

  pushNewPage(injectee: ActionContext<S, R>, page: RouteConfig): Promise<any>;

  firstPage(injectee: ActionContext<S, R>): Promise<any> | void;

  navigateTo(injectee: ActionContext<S, R>, page: string, params?: any): Promise<any> | void;

  processPages(
    injectee: ActionContext<S, R>,
    signupPages: ISignupPage[],
  ): any | string | Promise<string>;

  goToError(injectee: ActionContext<S, R>, error: { title?: string; message?: string }): void;

  next(injectee: ActionContext<S, R>): Promise<string> | string;
  previous(injectee: ActionContext<S, R>): Promise<string> | string;

  sync(injectee: ActionContext<S, R>, payload: { to?: string; query?: any }): Promise<any> | void;

  skip(injectee: ActionContext<S, R>): Promise<string> | string;

  jump(injectee: ActionContext<S, R>, to: number, params?: any): number;
}
/* /Actions */

export enum Mutations {
  SET_PAGE = 'SET_PAGE',
  /* There's a plugin that checks for set_page */
  // SYNC_PAGE = 'SYNC_PAGE',
  SET_PAGES = 'SET_PAGES',
  SET_COMPONENTS = 'SET_COMPONENTS',
  SET_COLLECTIONS_PAGE = 'SET_COLLECTIONS_PAGE',
  SET_COLLECTIONS_EMPLOYMENT_PAGE = 'SET_COLLECTIONS_EMPLOYMENT_PAGE',
  SET_COLLECTIONS_BAU_PRIORITY_PAGE = 'SET_COLLECTIONS_BAU_PRIORITY_PAGE',
  SET_COLLECTIONS_BUS_PAGE = 'SET_COLLECTIONS_BUS_PAGE',
  SET_COLLECTIONS_BUS_EMPLOYMENT_PAGE = 'SET_COLLECTIONS_BUS_EMPLOYMENT_PAGE',
}

type MutationType<S, E, K = keyof keyof E> = { [k in keyof K]: MutationTree<S> };

export type module = AsStoreModule<
  IState,
  IGetters,
  IStoreActions<IState, IRootState>,
  MutationType<IState, Mutations>
>;
export default createNamespacedHelpers('navigation') as AsModuleHelper<IState, IGetters, IActions>;
